/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnalyticsSignalName,
  AnalyticsSignalName$inboundSchema,
} from "./analyticssignalname.js";
import {
  AnalyticsSignalSensor,
  AnalyticsSignalSensor$inboundSchema,
} from "./analyticssignalsensor.js";

export type AnalyticsSignalCatalog = {
  dataset: string;
  initialAttributes: Array<string>;
  maxGroups: number;
  maxPoints: number;
  maxSpanDays: number;
  operators: Array<string>;
  population: string;
  sensors: Array<AnalyticsSignalSensor>;
  signals: Array<AnalyticsSignalName>;
  steps: Array<string>;
  systemDimensions: Array<string>;
  unit: string;
};

/** @internal */
export const AnalyticsSignalCatalog$inboundSchema: z.ZodMiniType<
  AnalyticsSignalCatalog,
  unknown
> = z.pipe(
  z.object({
    dataset: z.string(),
    initial_attributes: z.array(z.string()),
    max_groups: z.int(),
    max_points: z.int(),
    max_span_days: z.int(),
    operators: z.array(z.string()),
    population: z.string(),
    sensors: z.array(AnalyticsSignalSensor$inboundSchema),
    signals: z.array(AnalyticsSignalName$inboundSchema),
    steps: z.array(z.string()),
    system_dimensions: z.array(z.string()),
    unit: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "initial_attributes": "initialAttributes",
      "max_groups": "maxGroups",
      "max_points": "maxPoints",
      "max_span_days": "maxSpanDays",
      "system_dimensions": "systemDimensions",
    });
  }),
);

export function analyticsSignalCatalogFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsSignalCatalog, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsSignalCatalog$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsSignalCatalog' from JSON`,
  );
}
